/**
 * Application header.
 */

import React from 'react';
import { Text } from '@fluentui/react-components';
import { APP_META } from '@excel-ai-studio/shared';

export const Header: React.FC = () => (
  <div
    className="app-header"
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      padding: '12px 16px',
      borderBottom: '1px solid var(--border-color)',
      background: 'var(--card-bg)',
    }}
  >
    <div
      style={{
        width: 28,
        height: 28,
        borderRadius: 6,
        background: 'linear-gradient(135deg, #0078d4, #50e6ff)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontWeight: 700,
        fontSize: 14,
      }}
    >
      AI
    </div>
    <div>
      <Text weight="semibold" size={400}>
        {APP_META.NAME}
      </Text>
      <Text
        size={200}
        style={{ display: 'block', color: 'var(--text-secondary)', marginTop: -2 }}
      >
        Assistant intelligent pour Excel
      </Text>
    </div>
  </div>
);
